// eslint-disable-next-line import/no-extraneous-dependencies
import { combineReducers } from 'redux';

import CompanyReducer from './CompanyReducer';
import DashboardReducer from './DashboardReducer';
import DeptReducer from './DeptReducer';
import ELCAlarmDataReducer from './ELCAlarmDataReducer';
import ELCCabinetReducer from './ELCCabinetReducer';
import ELCControllerReducer from './ELCControllerReducer';
import ELCDoorSwitchReducer from './ELCDoorSwitchReducer';
import GuestReducer from './GuestReducer';
import InteractionReducer from './InteractionReducer';
import KeyboxReducer from './KeyboxReducer';
import KeyRecordReducer from './KeyRecordReducer';
import KeyReducer from './KeyReducer';
import LockEventDataReducer from './LockEventDataReducer';
import LockRecordReducer from './LockRecordReducer';
import LockReducer from './LockReducer';
import LogReducer from './LogReducer';
import MQTTReducer from './MQTTReducer';
import ProfileReducer from './ProfileReducer';
import RoleReducer from './RoleReducer';
import SDKReducer from './SDKReducer';
import SystemReducer from './SystemReducer';
import TaskRecordReducer from './TaskRecordReducer';
import TaskReducer from './TaskReducer';
import TaskUpdatingReducer from './TaskUpdatingReducer';
import UserReducer from './UserReducer';
import WorkerReducer from './WorkerReducer';

const allReducers = {
  companyReducer: CompanyReducer,
  deptReducer: DeptReducer,
  userReducer: UserReducer,
  roleReducer: RoleReducer,
  workerReducer: WorkerReducer,
  lockReducer: LockReducer,
  keyReducer: KeyReducer,
  keyRecordReducer: KeyRecordReducer,
  lockRecordReducer: LockRecordReducer,

  dashboardReducer: DashboardReducer,

  profileReducer: ProfileReducer,

  sdkReducer: SDKReducer,
  systemReducer: SystemReducer,

  guestReducer: GuestReducer,

  mqttReducer: MQTTReducer,

  interactionReducer: InteractionReducer,

  taskReducer: TaskReducer,

  taskRecordReducer: TaskRecordReducer,

  logReducer: LogReducer,

  keyboxReducer: KeyboxReducer,
  elcCabinetReducer: ELCCabinetReducer,
  elcControllerReducer: ELCControllerReducer,
  elcDoorSwitchReducer: ELCDoorSwitchReducer,
  elcAlarmDataReducer: ELCAlarmDataReducer,
  lockEventDataReducer: LockEventDataReducer,
  taskUpdatingReducer: TaskUpdatingReducer,
};

export default combineReducers(allReducers);
